import { MCP_TOOLS } from "@flowstepdesign/shared";
// FAQ copy for the MCP article pages, shared between each page's body
// and its route's FAQPage structured data.

export const VS_FIGMA_FAQS = [
  {
    question: "Can I run the Flowstep and Figma MCP servers together?",
    answer:
      "Yes, and many teams do. MCP clients connect to several servers at once, and the agent picks tools per task: Figma's tools when the job starts from an existing Figma file, Flowstep's when the job is to generate or change a screen. There is no conflict between them.",
  },
  {
    question: "Can Flowstep work with designs that live in Figma?",
    answer: `Yes. Flowstep's ${MCP_TOOLS.importFigma.name} tool brings a Figma frame onto the Flowstep canvas as editable elements, so an agent can generate the missing states and variants around a design that already exists.`,
  },
  {
    question: "Can I move Flowstep output into Figma?",
    answer:
      "Yes. Screens on the Flowstep canvas copy straight into Figma, and they also export as React, TypeScript and Tailwind for the implementation side.",
  },
  {
    question: "Which one should a team connect first?",
    answer:
      "Start from where your designs are born. If most work begins as a prompt or a PRD and there is no design yet, Flowstep's server covers the generation loop. If most work begins from finished Figma files that engineers implement, Figma's server covers the context loop. Teams doing both connect both.",
  },
];

export const BEST_SERVERS_FAQS = [
  {
    question: "What is an MCP server?",
    answer:
      "An MCP server is a program that exposes tools to AI assistants over the Model Context Protocol, an open standard. Your client (an editor, a terminal agent, a chat app) connects to the server, discovers its tools, and calls them on your behalf — reading a design file, generating a screen, running a browser, filing a ticket.",
  },
  {
    question: "Do MCP servers work with any client?",
    answer:
      "Mostly, yes. MCP is an open protocol, so a server written for one client generally works in the others. Claude Code, Cursor, Claude, Windsurf and Codex all support MCP servers; remote servers connect with a URL, local ones run as a process on your machine.",
  },
  {
    question: "How many MCP servers should I connect?",
    answer:
      "Fewer than you think. Every server's tools take up context the agent must reason over, so connect the ones your daily work actually calls: one for design, one for your repo, one for verification is a strong baseline. Add the rest per project.",
  },
  {
    question: "Are MCP servers safe to connect?",
    answer:
      "Treat a server like any dependency: know who publishes it and what it can access. Prefer servers with scoped OAuth sign-in over pasted API keys, and remember an agent can call any tool a server exposes, so a server's permissions are effectively the agent's permissions.",
  },
];

export const WHAT_IS_MCP_FAQS = [
  {
    question: "Is MCP only for programmers?",
    answer:
      "No. MCP clients include chat apps, not just editors. Adding a server to Claude, for example, is one click in its connector directory — after that, asking for work in plain language is the whole interface. The protocol is technical; using it isn't.",
  },
  {
    question: "Who created MCP?",
    answer:
      "Anthropic introduced the Model Context Protocol in November 2024 and released it as an open standard. It is not tied to one vendor: Claude, Cursor, Windsurf, OpenAI's Codex and many other clients support it, and anyone can publish a server.",
  },
  {
    question: "What's the difference between an MCP client and a server?",
    answer:
      "The client is the app you talk to — an editor, a terminal agent, a chat app. A server is a program that offers tools the client's AI can call. One client can connect to many servers, and one server can serve many clients.",
  },
  {
    question: "Does using MCP require an API key?",
    answer:
      "Not necessarily. Well-built remote servers authenticate with OAuth: your client opens a browser, you sign in to the service, and the client stores a scoped token. Flowstep's server works exactly this way — there is no key to create or paste.",
  },
];
